/* eslint-disable */

import { useEffect, useMemo, useState } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Box,
  Typography,
  Autocomplete,
  CircularProgress,
  Alert,
  Chip,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from '@mui/material';
import { fetcher, postFetcher } from 'src/utils/axios';

const AddCostDialog = ({
  open,
  onClose,
  onSave,
  enqueueSnackbar,
  selectedOutputUnits,
  onRefresh,
  rawMaterialInputs,
  finalproduct,
  selectedProduct, // Added selectedProduct prop
  fetchCostList,
  previousNodeInputs
}) => {
  const [costName, setCostName] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('fixed');
  const [unit, setUnit] = useState('');
  const [attributesList, setAttributesList] = useState([]);
  const stableRawMaterialInputs = useMemo(() => rawMaterialInputs || [], [rawMaterialInputs]);
console.log('previousinout',previousNodeInputs)
  const [tiers, setTiers] = useState([
    { 
      min: 1, 
      max: 500, 
      price: '', 
      pricingType: 'simple', 
      formula: '',
      unitRequired: false 
    },
    { 
      min: 501, 
      max: '', 
      price: '', 
      pricingType: 'simple', 
      formula: '',
      unitRequired: false 
    },
  ]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Multi-teared states
  const operators = ['>', '<', '=', '>=', '<=', '-'];
  const [availableAttributes, setAvailableAttributes] = useState([]);
  const [attributeOptions, setAttributeOptions] = useState([]);
  const [newAttr, setNewAttr] = useState('');
  const [multiTiers, setMultiTiers] = useState([
    {
      attributes: [],
      is_breakdown: false,
      subTiers: [], // only used when is_breakdown = true
      price: { name: null, per_unit: false, rate: '' }, // used when is_breakdown = false
      // New tier-level rounding fields
      is_round: false,
      is_ceil: false,
      roundoff_multiple: '',
    },
  ]);
  const [defaultPrice, setDefaultPrice] = useState('');
  const [defaultPerUnit, setDefaultPerUnit] = useState(true);

  // Build Cost Formula states (for fixed and tiered)
  const [costFormula, setCostFormula] = useState('');
  const [finalUnit, setFinalUnit] = useState(null);
  const [costPerUnit, setCostPerUnit] = useState('');
  const [useFormulaForFixed, setUseFormulaForFixed] = useState(false);
  // NEW: Per Unit Required for Fixed tab
  const [fixedUnitRequired, setFixedUnitRequired] = useState(false);

  console.log('rawMaterialInputs', rawMaterialInputs);

  const handleTypeChange = (event, newValue) => {
    setType(newValue);
    // Reset formula states when switching
    setCostFormula('');
    setFinalUnit(null);
    setCostPerUnit('');
    setUseFormulaForFixed(false);
    setFixedUnitRequired(false); // Reset fixed unit required when switching tabs
  };

  const handleAddTier = () => {
    const lastTier = tiers[tiers.length - 1];
    const newMin = lastTier.max ? Number(lastTier.max) + 1 : 1;
    setTiers([...tiers, { 
      min: newMin, 
      max: '', 
      price: '', 
      pricingType: 'simple', 
      formula: '',
      unitRequired: false 
    }]);
  };


const fetchLinkedAttributes = async () => {
  if (!previousNodeInputs || previousNodeInputs.length === 0) {
    return;
  }

  try {
    const res = await fetcher(`/new/workflow-app/node/${previousNodeInputs[0].backendId}/`);
    console.log('fetchLinkedAttributes', res?.output_foreign[0]?.linked_attributes);

    const linkedAttrs = res?.output_foreign[0]?.linked_attributes || [];
    if (!linkedAttrs.length) {
      return;
    }

    const mergedLinkedAttrsByProduct = linkedAttrs.reduce((acc, link) => {
      const productId = Number(link.productId);
      if (!acc[productId]) {
        acc[productId] = {
          id: productId,
          name: `Product ${productId}`,
          attributes: [],
          isLinkedAttribute: true,
        };
      }
      if (link.attribute && !acc[productId].attributes.includes(link.attribute)) {
        acc[productId].attributes.push(link.attribute);
      }
      return acc;
    }, {});

    setAttributesList((prevList) => {
      const existingMap = new Map(prevList.map((attr) => [attr.id, attr]));
      Object.values(mergedLinkedAttrsByProduct).forEach((linkedAttr) => {
        if (existingMap.has(linkedAttr.id)) {
          const existing = existingMap.get(linkedAttr.id);
          const mergedAttributes = [
            ...new Set([...(existing.attributes || []), ...(linkedAttr.attributes || [])]),
          ];
          existingMap.set(linkedAttr.id, {
            ...existing,
            attributes: mergedAttributes,
          });
        } else {
          existingMap.set(linkedAttr.id, linkedAttr);
        }
      });
      return Array.from(existingMap.values());
    });
  } catch (error) {
    console.error('Error fetching linked attributes:', error);
  }
};
useEffect(() => {
  const fetchAllAttributes = async () => {
    await fetchAttributes();

    if (previousNodeInputs && previousNodeInputs.length > 0) {
      await fetchLinkedAttributes();
    }
  };

  fetchAllAttributes();
}, [stableRawMaterialInputs, finalproduct, previousNodeInputs]);

  const handleRemoveTier = (index) => {
    if (tiers.length > 1) {
      setTiers(tiers.filter((_, i) => i !== index));
    }
  };

  const handleTierChange = (index, field, value) => {
    const newTiers = [...tiers];
    newTiers[index][field] = value;
    setTiers(newTiers);
  };

  // Multi-teared handlers
  const initialAvailable = useMemo(() => {
    return [...new Set(attributesList.flatMap((item) => item.attributes || []))];
  }, [attributesList]);

  useEffect(() => {
    setAvailableAttributes(initialAvailable);

    const options = attributesList.flatMap((item) =>
      (item.attributes || []).map((attr) => ({
        id: item.id,
        name: attr,
        display: attr,
        payloadValue: `p${item.id}.${attr}`,
      }))
    );

    const uniqueOptions = Array.from(
      options.reduce((map, option) => {
        if (!map.has(option.name)) {
          map.set(option.name, option);
        }
        return map;
      }, new Map())
      .values()
    );

    setAttributeOptions(uniqueOptions);
  }, [attributesList, initialAvailable]);

  // Update handleAddMultiTier
  const handleAddMultiTier = () => {
    setMultiTiers([
      ...multiTiers,
      {
        attributes: [],
        is_breakdown: false,
        subTiers: [], // only used when is_breakdown = true
        price: { name: null, per_unit: false, rate: '' }, // used when is_breakdown = false
        // New tier-level rounding fields
        is_round: false,
        is_ceil: false,
        roundoff_multiple: '',
      },
    ]);
  };

  const handleRemoveMultiTier = (index) => {
    if (multiTiers.length > 1) {
      setMultiTiers(multiTiers.filter((_, i) => i !== index));
    }
  };

  const handleAddCond = (tierIdx) => {
    setMultiTiers((prev) =>
      prev.map((t, i) =>
        i === tierIdx
          ? { ...t, attributes: [...t.attributes, { name: '', operator: '', value: '' }] }
          : t
      )
    );
  };

  const handleRemoveCond = (tierIdx, condIdx) => {
    setMultiTiers((prev) =>
      prev.map((t, i) =>
        i === tierIdx ? { ...t, attributes: t.attributes.filter((_, j) => j !== condIdx) } : t
      )
    );
  };

  const handleCondChange = (tierIdx, condIdx, field, value) => {
    setMultiTiers((prev) =>
      prev.map((t, i) =>
        i === tierIdx
          ? {
              ...t,
              attributes: t.attributes.map((c, j) =>
                j === condIdx ? { ...c, [field]: value } : c
              ),
            }
          : t
      )
    );
  };

  // Formula builder handlers
  const handleAttributeClick = (attributeName) => {
    // Find the attribute option by name
    const attrOption = attributeOptions.find(opt => opt.name === attributeName);
    if (attrOption) {
      // Display the name in the formula field
      setCostFormula((prev) => prev + attrOption.name);
    }
  };

  const handleOperatorClick = (operator) => {
    setCostFormula((prev) => prev + operator);
  };

  const handleBackspace = (e) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      setCostFormula((prev) => prev.slice(0, -1));
    }
  };

  const handleFinalUnitChange = (event, newValue) => {
    setFinalUnit(newValue);
  };

  const isFinalUnitMatching = () => {
    return finalUnit?.name === selectedProduct?.measurement_unit;
  };

  const units = selectedOutputUnits || [];

  // Function to convert display formula to payload formula
  const convertFormulaForPayload = (formula) => {
    if (!formula) return '';
    
    let convertedFormula = formula;
    // Replace each attribute name with its payload value
    attributeOptions.forEach(attr => {
      const regex = new RegExp(attr.name, 'g');
      convertedFormula = convertedFormula.replace(regex, attr.payloadValue);
    });
    return convertedFormula;
  };

  const handleSave = async () => {
    setLoading(true);
    setError('');
      const rawMaterialIds = stableRawMaterialInputs.map((material) => Number(material.value));
      const finalProductIds =
        finalproduct && Array.isArray(finalproduct)
          ? finalproduct.map((product) => Number(product.id))
          : [];
      const productIds = [...rawMaterialIds, ...finalProductIds];
    // Basic validation
    if (!costName.trim()) {
      setError('Cost name is required');
      setLoading(false);
      return;
    }

    if (type === 'fixed') {
      if (useFormulaForFixed) {
        if (!costFormula.trim()) {
          setError('Cost formula is required');
          setLoading(false);
          return;
        }
      } else {
        if (!amount) {
          setError('Amount is required for fixed costs');
          setLoading(false);
          return;
        }
      }
    }

    if (type === 'tiered') {
      for (const [index, tier] of tiers.entries()) {
        if (tier.pricingType === 'simple' && !tier.price) {
          setError(`Tier ${index + 1} must have a price`);
          setLoading(false);
          return;
        }
        if (tier.pricingType === 'formula' && !tier.formula) {
          setError(`Tier ${index + 1} must have a formula`);
          setLoading(false);
          return;
        }
      }
    }

    if (type === 'multi_teared') {
      // Multi-tiered validation (unchanged)
      if (
        !multiTiers.every((tier) => {
          if (tier.is_breakdown) {
            return (
              tier.attributes.length > 0 &&
              tier.attributes.every((c) => c.name && c.operator && c.value) &&
              tier.subTiers?.length > 0 &&
              tier.subTiers.every((s) => s.value && s.rate)
            );
          }
          return (
            tier.attributes.length > 0 &&
            tier.attributes.every((c) => c.name && c.operator && c.value) &&
            tier.price.rate
          );
        })
      ) {
        setError('All tiers must have valid conditions and pricing (breakdown tiers need slabs)');
        setLoading(false);
        return;
      }

      if (!defaultPrice) {
        setError('Default price is required');
        setLoading(false);
        return;
      }

      // Range validation and overlap check
      const rangesByAttr = {};
      multiTiers.forEach((tier, tierIdx) => {
        tier.attributes.forEach((cond) => {
          if (cond.operator === '-' && cond.name) {
            const parts = cond.value.split('-').map((p) => p.trim());
            if (parts.length === 2) {
              const min = Number(parts[0]);
              const max = Number(parts[1]);
              if (isNaN(min) || isNaN(max) || min >= max) {
                setError(`Invalid range for ${cond.name} in tier ${tierIdx + 1}`);
                setLoading(false);
                return;
              }
              if (!rangesByAttr[cond.name]) rangesByAttr[cond.name] = [];
              rangesByAttr[cond.name].push({ min, max, tierIdx });
            } else {
              setError(`Invalid range format for ${cond.name} in tier ${tierIdx + 1}`);
              setLoading(false);
              return;
            }
          }
        });
      });
      for (const [attr, rgs] of Object.entries(rangesByAttr)) {
        if (rgs.length > 1) {
          const sorted = [...rgs].sort((a, b) => a.min - b.min);
          for (let k = 1; k < sorted.length; k++) {
            if (sorted[k].min <= sorted[k - 1].max) {
              setError(
                `Overlapping ranges for attribute ${attr} between tiers ${
                  sorted[k].tierIdx + 1
                } and ${sorted[k - 1].tierIdx + 1}`
              );
              setLoading(false);
              return;
            }
          }
        }
      }

      // Construct payload for multi-tiered
      const multi_teared = multiTiers
        .map((tier) => {
          const base = {
            attributes: tier.attributes.map((cond) => ({
              name: cond.name,
              operator: cond.operator,
              value: cond.value,
            })),
            is_breakdown: tier.is_breakdown,

            ...(tier.is_breakdown && {
              is_round: tier.is_round,
              is_ceil: tier.is_ceil,
              roundoff_multiple: tier.roundoff_multiple ? Number(tier.roundoff_multiple) : null,
            }),
          };

          if (tier.is_breakdown) {
            base.price = tier.subTiers.map((s) => ({
              name: s.name || tier.price?.name || null,
              operator: s.operator || '<=',
              value: s.value,
              rate: Number(s.rate),
              per_unit: s.per_unit,
              per: s.per === null || s.per === '' ? null : Number(s.per),
            }));
          } else {
            base.price = {
              name: tier.price.name || null,
              per_unit: tier.price.per_unit,
              rate: Number(tier.price.rate),
            };
          }

          return base;
        })
        .concat([
          {
            is_default: true,
            is_breakdown: false,
            per_unit: defaultPerUnit,
            default_price: Number(defaultPrice),
          },
        ]);

      const payload = {
        name: costName.trim(),
        description: description.trim(),
        unit: unit.trim(),
        multi_teared,
        productIds: productIds.length ? productIds : undefined, // Only include if there are products
      };

      try {
        const res = await postFetcher(['/new/workflow-app/multi-teared-cost-create/', payload]);
        console.log('Multi-teared cost created successfully:', res);
        if(res){
           fetchCostList()
        }
        if (onRefresh) {
          onRefresh();
        }
        onClose();
      } catch (err) {
        console.error('Failed to create multi-teared cost:', err);
        setError(err.message || 'Failed to save cost. Please try again.');
      } finally {
       
        setLoading(false);
      }
      return;
    }

    // Handle fixed and tiered saves
    let value = {};

    if (type === 'fixed') {
      if (useFormulaForFixed) {
        value = {
          formula: {
            expression: convertFormulaForPayload(costFormula.trim()),
            final_unit: finalUnit?.name,
            per_unit:fixedUnitRequired,
            // cost_per_unit: parseFloat(costPerUnit) || null,
          },
        };
      } else {
        value = { 
          amount: Number(amount),
          // NEW: Add unitRequired for fixed costs when not using formula
          ...(fixedUnitRequired && { unitRequired: fixedUnitRequired })
        };
      }
    } else if (type === 'tiered') {
      value = {
        tiers: tiers.map((t) => ({
          min: Number(t.min),
          max: t.max === '' || t.max === null ? null : Number(t.max),
          per_unit: t.unitRequired,
          ...(t.pricingType === 'simple' 
            ? { price: Number(t.price) }
            : { 
                formula: {
                  expression: convertFormulaForPayload(t.formula.trim()),
                  final_unit: finalUnit?.name,
                }
              }
          ),
        })),
      };
    }

    const payload = {
      name: costName.trim(),
      value,
      description: description.trim(),
      cost_type: type,
      unit: unit.trim(),
      productIds: productIds.length ? productIds : undefined, // Only include if there are products
    };

    try {
      const res = await postFetcher([`new/workflow-app/costs/`, payload]);

      console.log('Cost created successfully:', res);
  if(res){
           fetchCostList()
        }
      // Trigger refresh in parent (e.g., to reload costs list)
      if (onRefresh) {
        onRefresh();
      }

      // Close dialog on success
      onClose();
    } catch (err) {
      console.error('Failed to create cost:', err);
      setError(err.message || 'Failed to save cost. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const fetchAttributes = async () => {
    try {
      console.log(
        'fetchAttributes called with stableRawMaterialInputs:',
        stableRawMaterialInputs,
        'finalproduct:',
        finalproduct
      );
      const rawMaterialIds = stableRawMaterialInputs.map((material) => Number(material.value));
      const finalProductIds =
        finalproduct && Array.isArray(finalproduct)
          ? finalproduct.map((product) => Number(product.id))
          : [];
      const productIds = [...rawMaterialIds, ...finalProductIds];
      console.log('productIds:', productIds);
      if (!productIds.length) {
        console.log('No product IDs provided');
        setAttributesList([]);
        return;
      }
      const payload = { product_ids: productIds };
      console.log('Fetching attributes with payload:', payload);
      const res = await postFetcher(['/new/workflow-app/products/attributes/key/', payload]);
      console.log('Fetch Attributes Response:', res);
      if (res) {
        const attributes = Array.isArray(res)
          ? res.map((item) => ({
              name: item.name,
              attributes: item.attributes || [],
              id: item.id,
            }))
          : res.data?.map((item) => ({
              name: item.name,
              attributes: item.attributes || [],
              id: item.id,
            })) || [];
        console.log('Processed Attributes:', attributes);
        setAttributesList(attributes.length ? attributes : []);
        
        // Extract cost per unit if available
        if (attributes[0]?.cost_per_unit) {
          setCostPerUnit(attributes[0].cost_per_unit);
        }
      } else {
        console.log('No data in response');
        setAttributesList([]);
      }
    } catch (error) {
      console.error('Error fetching attributes:', error);
      setAttributesList([]);
      enqueueSnackbar('Failed to fetch attributes', { variant: 'error' });
    }
  };

  const isSaveDisabled =
    loading ||
    !costName.trim() ||
    (type === 'fixed' && (
      useFormulaForFixed 
        ? !costFormula.trim()  // Removed !finalUnit from here
        : !amount
    )) ||
    (type === 'tiered' && tiers.some((t) => 
      t.pricingType === 'simple' ? !t.price : !t.formula
    )) ||
    (type === 'multi_teared' &&
      (!multiTiers.every((tier) => {
        const hasValidConditions =
          tier.attributes.length > 0 &&
          tier.attributes.every((cond) => cond.name && cond.operator && cond.value);

        if (tier.is_breakdown) {
          return (
            hasValidConditions &&
            tier.subTiers?.length > 0 &&
            tier.subTiers.every((s) => s.name && s.operator && s.value && s.rate)
          );
        }

        return hasValidConditions && tier.price?.rate;
      }) ||
        !defaultPrice));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Add New Cost</DialogTitle>
      <DialogContent>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={type} onChange={handleTypeChange} centered>
            <Tab label="Fixed" value="fixed" />
            <Tab label="Tiered" value="tiered" />
            <Tab label="Multi-Tiered" value="multi_teared" />
          </Tabs>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <TextField
          label="Cost Name"
          fullWidth
          margin="normal"
          value={costName}
          onChange={(e) => setCostName(e.target.value)}
          disabled={loading}
        />

        {type === 'fixed' && (
          <>
            {/* NEW: Per Unit Required switch for Fixed tab */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={fixedUnitRequired}
                      onChange={(e) => setFixedUnitRequired(e.target.checked)}
                      size="small"
                      disabled={loading}
                    />
                  }
                  label="Per Unit Required"
                />
                <br/>
            <FormControl component="fieldset" sx={{ mt: 2, mb: 2 }}>
              <FormLabel component="legend">Pricing Type</FormLabel>
              <RadioGroup
                row
                value={useFormulaForFixed ? 'formula' : 'simple'}
                onChange={(e) => setUseFormulaForFixed(e.target.value === 'formula')}
              >
                <FormControlLabel value="simple" control={<Radio />} label="Simple Amount" />
                <FormControlLabel value="formula" control={<Radio />} label="Use Formula" />
              </RadioGroup>
            </FormControl>
   
            {useFormulaForFixed ? (
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Build Cost Formula
                  </Typography>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                    {attributeOptions.map((attr) => (
                      <Chip
                        key={attr.display}
                        label={attr.display}
                        onClick={() => handleAttributeClick(attr.name)}
                        color="primary"
                        variant="outlined"
                        size="small"
                        sx={{ cursor: 'pointer' }}
                      />
                    ))}

                    {costPerUnit && !isNaN(parseFloat(costPerUnit)) && parseFloat(costPerUnit) > 0 && (
                      <Chip
                        label={`cost_per_unit (${costPerUnit})`}
                        onClick={() => handleOperatorClick(costPerUnit)}
                        color="success"
                        variant="soft"
                        size="small"
                        sx={{ cursor: 'pointer' }}
                      />
                    )}
                  </Box>

                  <TextField
                    fullWidth
                    label="Cost Formula"
                    value={costFormula}
                    onChange={(e) => setCostFormula(e.target.value)}
                    onKeyDown={handleBackspace}
                    multiline
                    rows={3}
                    sx={{ mb: 2 }}
                    placeholder="e.g., LENGTH * WIDTH * gsm"
                    helperText="Click on attribute chips to add them to the formula"
                  />

                  <Typography variant="body2" sx={{ mb: 2, fontStyle: 'italic' }}>
                    Final result will be multiplied by cost per unit.
                  </Typography>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
                    {['+', '-', '*', '/', '(', ')', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map((op) => (
                      <Chip
                        key={op}
                        label={op}
                        onClick={() => handleOperatorClick(op)}
                        color="secondary"
                        variant="filled"
                        size="small"
                        sx={{ cursor: 'pointer' }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  label="Amount"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  InputProps={{ inputProps: { min: 0, step: '0.01' } }}
                  disabled={loading}
                  sx={{ flex: 1, minWidth: '200px' }}
                />
           
              </Box>
            )}
          </>
        )}

        {type === 'tiered' && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Tiered Pricing
            </Typography>
            {tiers.map((tier, index) => (
              <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3, p: 2, border: '1px solid', borderColor: 'grey.300', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  <TextField
                    label="Min Quantity"
                    type="number"
                    value={tier.min}
                    onChange={(e) => handleTierChange(index, 'min', e.target.value)}
                    sx={{ width: 140 }}
                    disabled={loading}
                  />
                  <TextField
                    label="Max Quantity"
                    type="number"
                    placeholder="Leave empty for ∞"
                    value={tier.max ?? ''}
                    onChange={(e) => handleTierChange(index, 'max', e.target.value)}
                    sx={{ width: 140 }}
                    disabled={loading}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={tier.unitRequired || false}
                        onChange={(e) => handleTierChange(index, 'unitRequired', e.target.checked)}
                        size="small"
                      />
                    }
                    label="Per Unit Required"
                  />
                  {tiers.length > 1 && (
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleRemoveTier(index)}
                      disabled={loading}
                    >
                      Remove
                    </Button>
                  )}
                </Box>

                <FormControl component="fieldset">
                  <FormLabel component="legend">Pricing Type for Tier {index + 1}</FormLabel>
                  <RadioGroup
                    row
                    value={tier.pricingType}
                    onChange={(e) => handleTierChange(index, 'pricingType', e.target.value)}
                  >
                    <FormControlLabel value="simple" control={<Radio />} label="Simple Price" />
                    <FormControlLabel value="formula" control={<Radio />} label="Use Formula" />
                  </RadioGroup>
                </FormControl>

                {tier.pricingType === 'simple' ? (
                  <TextField
                    label="Price"
                    type="number"
                    value={tier.price}
                    onChange={(e) => handleTierChange(index, 'price', e.target.value)}
                    InputProps={{ inputProps: { step: '0.01' } }}
                    sx={{ width: 140 }}
                    disabled={loading}
                  />
                ) : (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" gutterBottom>
                      Available Attributes
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                      {attributeOptions.map((attr) => (
                        <Chip
                          key={attr.display}
                          label={attr.display}
                          onClick={() => {
                            const currentFormula = tier.formula || '';
                            handleTierChange(index, 'formula', currentFormula + attr.name);
                          }}
                          color="primary"
                          variant="outlined"
                          size="small"
                          sx={{ cursor: 'pointer' }}
                        />
                      ))}
                    </Box>

                    <TextField
                      fullWidth
                      label={`Formula for Tier ${index + 1}`}
                      value={tier.formula || ''}
                      onChange={(e) => handleTierChange(index, 'formula', e.target.value)}
                      onKeyDown={handleBackspace}
                      multiline
                      rows={2}
                      sx={{ mb: 1 }}
                      placeholder="e.g., LENGTH * WIDTH * gsm"
                      helperText="Click on attribute chips to add them to the formula"
                    />

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
                      {['+', '-', '*', '/', '(', ')', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map((op) => (
                        <Chip
                          key={op}
                          label={op}
                          onClick={() => {
                            const currentFormula = tier.formula || '';
                            handleTierChange(index, 'formula', currentFormula + op);
                          }}
                          color="secondary"
                          variant="filled"
                          size="small"
                          sx={{ cursor: 'pointer' }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            ))}
            <Button variant="outlined" onClick={handleAddTier} disabled={loading}>
              Add Tier
            </Button>
          </Box>
        )}

        {type === 'multi_teared' && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Multi-Tiered Pricing (with Breakdown Support)
            </Typography>
            <Typography variant="body2" gutterBottom color="text.secondary">
              Define rules based on attributes. Enable "Breakdown" for progressive slab pricing.
            </Typography>

            {/* Available Attributes Display */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Available Attributes
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                {attributeOptions.map((attr) => (
                  <Chip key={attr.display} label={attr.display} size="small" color="primary" />
                ))}
              </Box>
            </Box>

            {multiTiers.map((tier, tierIdx) => (
              <Box
                key={tierIdx}
                sx={{
                  p: 3,
                  border: 1,
                  borderColor: tier.is_breakdown ? 'primary.main' : 'grey.300',
                  borderRadius: 2,
                  mb: 3,
                  bgcolor: tier.is_breakdown ? 'primary.50' : 'white',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1">
                    Tier {tierIdx + 1} {tier.is_breakdown && '(Breakdown)'}
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={tier.is_breakdown || false}
                        onChange={(e) =>
                          setMultiTiers((prev) =>
                            prev.map((t, i) =>
                              i === tierIdx ? { ...t, is_breakdown: e.target.checked } : t
                            )
                          )
                        }
                        disabled={loading}
                      />
                    }
                    label="Enable Breakdown (Progressive Slabs)"
                  />
                </Box>

                {/* Attribute Conditions */}
                <Typography variant="body2" gutterBottom sx={{ mb: 1 }}>
                  Attribute Conditions (AND logic)
                </Typography>
                {tier.attributes.map((cond, condIdx) => (
                  <Box
                    key={condIdx}
                    sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1.5 }}
                  >
                    <Autocomplete
                      options={availableAttributes}
                      freeSolo
                      value={cond.name || null}
                      onChange={(_, v) => handleCondChange(tierIdx, condIdx, 'name', v)}
                      renderInput={(params) => (
                        <TextField {...params} label="Attribute" size="small" sx={{ width: 160 }} />
                      )}
                      size="small"
                      disabled={loading}
                    />
                    <Autocomplete
                      options={operators}
                      value={cond.operator || null}
                      onChange={(_, v) => handleCondChange(tierIdx, condIdx, 'operator', v)}
                      renderInput={(params) => (
                        <TextField {...params} label="Operator" size="small" sx={{ width: 110 }} />
                      )}
                      size="small"
                      disabled={loading}
                    />
                    {cond.operator === '-' ? (
                      <TextField
                        label="Range (min-max)"
                        placeholder="e.g. 100-200"
                        value={cond.value || ''}
                        onChange={(e) =>
                          handleCondChange(tierIdx, condIdx, 'value', e.target.value)
                        }
                        size="small"
                        sx={{ width: 160 }}
                        disabled={loading}
                      />
                    ) : (
                      <TextField
                        label="Value"
                        type="number"
                        value={cond.value || ''}
                        onChange={(e) =>
                          handleCondChange(tierIdx, condIdx, 'value', e.target.value)
                        }
                        size="small"
                        sx={{ width: 160 }}
                        inputProps={{ step: '0.01' }}
                        disabled={loading}
                      />
                    )}
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleRemoveCond(tierIdx, condIdx)}
                      disabled={loading}
                    >
                      Remove
                    </Button>
                  </Box>
                ))}
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => handleAddCond(tierIdx)}
                  disabled={loading}
                  sx={{ mt: 1 }}
                >
                  + Add Condition
                </Button>

                {/* New: Tier-level Rounding Controls – shown only when is_breakdown is true */}
                {tier.is_breakdown && (
                  <Box
                    sx={{
                      mt: 4,
                      p: 2,
                      border: 1,
                      borderColor: 'grey.400',
                      borderRadius: 1,
                      bgcolor: 'grey.50',
                    }}
                  >
                    
                    {/* is_round Switch */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={tier.is_round || false}
                          onChange={(e) =>
                            setMultiTiers((prev) =>
                              prev.map((t, i) =>
                                i === tierIdx ? { ...t, is_round: e.target.checked } : t
                              )
                            )
                          }
                          size="small"
                          disabled={loading}
                        />
                      }
                      label="Enable Rounding"
                    />

                    {/* Conditional: Roundoff Multiple + Floor/Ceil – shown only if is_round is true */}
                    {tier.is_round && (
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 3,
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          mt: 2,
                        }}
                      >
                        <TextField
                          label="Roundoff Multiple"
                          type="number"
                          value={tier.roundoff_multiple || ''}
                          onChange={(e) =>
                            setMultiTiers((prev) =>
                              prev.map((t, i) =>
                                i === tierIdx ? { ...t, roundoff_multiple: e.target.value } : t
                              )
                            )
                          }
                          size="small"
                          sx={{ width: 160 }}
                          inputProps={{ min: 1, step: '1' }}
                          disabled={loading}
                          helperText="e.g. 100"
                        />

                        <FormControlLabel
                          control={
                            <Switch
                              checked={tier.is_ceil || false}
                              onChange={(e) =>
                                setMultiTiers((prev) =>
                                  prev.map((t, i) =>
                                    i === tierIdx ? { ...t, is_ceil: e.target.checked } : t
                                  )
                                )
                              }
                              size="small"
                            />
                          }
                          label={tier.is_ceil ? 'Ceil (Round Up)' : 'Floor (Round Down)'}
                        />
                      </Box>
                    )}
                  </Box>
                )}

                {/* Price Configuration – changes based on is_breakdown */}
                <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: 'divider' }}>
                  <Typography variant="subtitle2" gutterBottom>
                    {tier.is_breakdown ? 'Breakdown Slabs (Progressive)' : 'Single Price'}
                  </Typography>

                  {tier.is_breakdown ? (
                    // Breakdown mode: list of sub-slabs with full condition fields + per + is_round
                    <Box sx={{ pl: 2, borderLeft: 3, borderColor: 'primary.light', mt: 1 }}>
                      {tier.subTiers?.map((sub, subIdx) => (
                        <Box
                          key={subIdx}
                          sx={{
                            display: 'flex',
                            gap: 2,
                            alignItems: 'center',
                            mb: 2,
                            flexWrap: 'wrap',
                            p: 1.5,
                            border: '1px dashed',
                            borderColor: 'grey.400',
                            borderRadius: 1,
                            bgcolor: 'grey.50',
                          }}
                        >
                          {/* Varies by Attribute (name) */}
                          <Autocomplete
                            options={availableAttributes}
                            freeSolo
                            value={sub.name || null}
                            onChange={(_, v) =>
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? {
                                        ...t,
                                        subTiers: t.subTiers.map((s, j) =>
                                          j === subIdx ? { ...s, name: v } : s
                                        ),
                                      }
                                    : t
                                )
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Varies by"
                                size="small"
                                sx={{ width: 160 }}
                              />
                            )}
                            size="small"
                            disabled={loading}
                          />

                          {/* Operator */}
                          <Autocomplete
                            options={operators}
                            value={sub.operator || '<='}
                            onChange={(_, v) =>
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? {
                                        ...t,
                                        subTiers: t.subTiers.map((s, j) =>
                                          j === subIdx ? { ...s, operator: v } : s
                                        ),
                                      }
                                    : t
                                )
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Operator"
                                size="small"
                                sx={{ width: 110 }}
                              />
                            )}
                            size="small"
                            disabled={loading}
                          />

                          {/* Value (bracket end) */}
                          <TextField
                            label="Bracket End"
                            type="number"
                            value={sub.value || ''}
                            onChange={(e) =>
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? {
                                        ...t,
                                        subTiers: t.subTiers.map((s, j) =>
                                          j === subIdx ? { ...s, value: e.target.value } : s
                                        ),
                                      }
                                    : t
                                )
                              )
                            }
                            size="small"
                            sx={{ width: 140 }}
                            inputProps={{ min: 1, step: '1' }}
                            disabled={loading}
                          />

                          {/* Rate */}
                          <TextField
                            label="Rate"
                            type="number"
                            value={sub.rate || ''}
                            onChange={(e) =>
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? {
                                        ...t,
                                        subTiers: t.subTiers.map((s, j) =>
                                          j === subIdx ? { ...s, rate: e.target.value } : s
                                        ),
                                      }
                                    : t
                                )
                              )
                            }
                            size="small"
                            sx={{ width: 120 }}
                            inputProps={{ step: '0.01' }}
                            disabled={loading}
                          />

                          {/* Per Unit Switch */}
                          <FormControlLabel
                            control={
                              <Switch
                                checked={sub.per_unit || false}
                                onChange={(e) =>
                                  setMultiTiers((prev) =>
                                    prev.map((t, i) =>
                                      i === tierIdx
                                        ? {
                                            ...t,
                                            subTiers: t.subTiers.map((s, j) =>
                                              j === subIdx
                                                ? { ...s, per_unit: e.target.checked }
                                                : s
                                            ),
                                          }
                                        : t
                                    )
                                  )
                                }
                                size="small"
                              />
                            }
                            label="Per Unit"
                          />

                          {/* Per Portion (null or number) */}
                          <TextField
                            label="Per Portion"
                            type="number"
                            placeholder="null or e.g. 500"
                            value={sub.per === null || sub.per === undefined ? '' : sub.per}
                            onChange={(e) => {
                              const val = e.target.value.trim();
                              const newPer = val === '' ? null : Number(val);
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? {
                                        ...t,
                                        subTiers: t.subTiers.map((s, j) =>
                                          j === subIdx ? { ...s, per: newPer } : s
                                        ),
                                      }
                                    : t
                                )
                              );
                            }}
                            size="small"
                            sx={{ width: 140 }}
                            inputProps={{ min: 1, step: '1' }}
                            disabled={loading}
                            helperText="Leave empty for null"
                          />

                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() =>
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? { ...t, subTiers: t.subTiers.filter((_, j) => j !== subIdx) }
                                    : t
                                )
                              )
                            }
                            disabled={loading}
                          >
                            Remove Slab
                          </Button>
                        </Box>
                      ))}

                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() =>
                          setMultiTiers((prev) =>
                            prev.map((t, i) =>
                              i === tierIdx
                                ? {
                                    ...t,
                                    subTiers: [
                                      ...(t.subTiers || []),
                                      {
                                        name: '',
                                        operator: '<=',
                                        value: '',
                                        rate: '',
                                        per_unit: false,
                                        per: null,
                                      },
                                    ],
                                  }
                                : t
                            )
                          )
                        }
                        disabled={loading}
                        sx={{ mt: 1 }}
                      >
                        + Add Slab
                      </Button>

                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 1, display: 'block' }}
                      >
                        Rounding applies only when "Per Portion" is set or "Per Unit" is enabled.
                      </Typography>
                    </Box>
                  ) : (
                    
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                      <Autocomplete
                        options={availableAttributes}
                        freeSolo
                        value={tier.price?.name || null}
                        onChange={(_, v) => {
                          setMultiTiers((prev) =>
                            prev.map((t, i) =>
                              i === tierIdx ? { ...t, price: { ...t.price, name: v } } : t
                            )
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Varies by"
                            size="small"
                            sx={{ width: 160 }}
                          />
                        )}
                        disabled={loading}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={tier.price?.per_unit || false}
                            onChange={(e) =>
                              setMultiTiers((prev) =>
                                prev.map((t, i) =>
                                  i === tierIdx
                                    ? { ...t, price: { ...t.price, per_unit: e.target.checked } }
                                    : t
                                )
                              )
                            }
                            disabled={loading}
                          />
                        }
                        label="Per Unit"
                      />
                      <TextField
                        label="Rate"
                        type="number"
                        value={tier.price?.rate || ''}
                        onChange={(e) =>
                          setMultiTiers((prev) =>
                            prev.map((t, i) =>
                              i === tierIdx
                                ? { ...t, price: { ...t.price, rate: e.target.value } }
                                : t
                            )
                          )
                        }
                        size="small"
                        sx={{ width: 140 }}
                        inputProps={{ step: '0.01' }}
                        disabled={loading}
                      />  
                    </Box>
                  )}
                </Box>
                {multiTiers.length > 1 && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleRemoveMultiTier(tierIdx)}
                    sx={{ mt: 3 }}
                    disabled={loading}
                  >
                    Remove Tier
                  </Button>
                )}
              </Box>
            ))}

            <Button
              variant="outlined"
              onClick={handleAddMultiTier}
              disabled={loading}
              sx={{ mb: 3 }}
            >
              + Add Tier
            </Button>

            {/* Default Tier */}
            <Box
              sx={{ p: 3, border: 1, borderColor: 'grey.400', borderRadius: 2, bgcolor: 'grey.50' }}
            >
              <Typography variant="subtitle1" gutterBottom>
                Default / Fallback Tier
              </Typography>
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
                <TextField
                  label="Default Price"
                  type="number"
                  value={defaultPrice}
                  onChange={(e) => setDefaultPrice(e.target.value)}
                  size="small"
                  sx={{ width: 160 }}
                  inputProps={{ step: '0.01', min: 0 }}
                  disabled={loading}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={defaultPerUnit}
                      onChange={(e) => setDefaultPerUnit(e.target.checked)}
                      disabled={loading}
                    />
                  }
                  label="Per Unit"
                />
              </Box>
            </Box>
          </Box>
        )}

        <TextField
          label="Description"
          fullWidth
          multiline
          rows={3}
          margin="normal"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          disabled={loading}
        />

        <Autocomplete
          options={selectedOutputUnits || []}
          getOptionLabel={(option) => option.name || ''}
          value={selectedOutputUnits?.find((u) => u.name === unit) || null}
          onChange={(event, newValue) => {
            setUnit(newValue ? newValue.name : '');
          }}
          renderInput={(params) => (
            <TextField {...params} label="Unit" fullWidth margin="normal" disabled={loading} />
          )}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          disabled={loading}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={isSaveDisabled}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCostDialog;